module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.testimonials.length) ? _c('section', {
    attrs: {
      "id": "testimonials"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', [_vm._v("Testimonials")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, _vm._l((_vm.testimonials), function(testimonial) {
    return _c('div', [(testimonial.testimonial) ? _c('div', [_c('div', {
      domProps: {
        "innerHTML": _vm._s(testimonial.testimonial)
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-right"
    }, [_c('strong', [_vm._v("—"), _c('span', {
      domProps: {
        "innerHTML": _vm._s(testimonial.name)
      }
    })]), _c('br'), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(testimonial.role)
      }
    }), _c('br'), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(testimonial.organization)
      }
    })])]) : _vm._e()])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "scrim"
  })]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-147f4b72!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OurTeam/Testimonials.vue
// module id = 383
// module chunks = 2